import Cookies from "js-cookie";

const updateWorkspacePrompt = async ({ commit, rootGetters, dispatch }, payload) => {
    commit("SET_IS_WORKSPACE_PROMPTS_ACTION_LOADING", true);
    try {
        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];
        const data = { ...payload, customer_id: customer.customer_id, userId: Cookies.get('userId') };

        if (customer.customer_id === 0) {
            data.customer_id = selected_customer.customer_id;
        }

        const response = await window.axios.put(`/proxy/ai/workspaces/${data.workspaceId}/workspace-prompts/${data.workspacePromptId}?customer_id=${data.customer_id}&search=${data.search || ''}`, data);
        if (response && response.data.success) {
            return response.data.prompt;
        } else {
            throw response.data;
        }
    } catch (error) {
        dispatch("notifications/setError", error.message, { root: true });
    } finally {
        commit("SET_IS_WORKSPACE_PROMPTS_ACTION_LOADING", false);
    }
};

export default updateWorkspacePrompt;